var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmcBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 116,
    viewBox: "0 0 334 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5222_29548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 334,
    height: 116
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 334,
    height: 116,
    rx: 12,
    fill: "#EEF8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 333,
    height: 115,
    rx: 11.5,
    stroke: "url(#paint0_linear_5222_29548)",
    strokeOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5222_29548)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5222_29548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 335,
    height: 117
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 117,
    rx: 12,
    transform: "matrix(-1 0 0 1 335 -1)",
    fill: "#E9F7EF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 334,
    height: 116,
    rx: 11.5,
    transform: "matrix(-1 0 0 1 334 -1)",
    stroke: "url(#paint1_linear_5222_29548)",
    strokeOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5222_29548)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 99.5,
    cy: 99.5,
    r: 99.5,
    transform: "matrix(-1 0 0 1 206 55)",
    fill: "#B5DDF5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5222_29548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 55,
    width: 199,
    height: 199
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.5,
    transform: "matrix(-1 0 0 1 206 55)",
    fill: "url(#paint2_linear_5222_29548)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5222_29548)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 213.881 55)",
    stroke: "url(#paint3_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 221.762 55)",
    stroke: "url(#paint4_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 229.644 55)",
    stroke: "url(#paint5_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 237.525 55)",
    stroke: "url(#paint6_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 245.406 55)",
    stroke: "url(#paint7_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 253.287 55)",
    stroke: "url(#paint8_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 261.168 55)",
    stroke: "url(#paint9_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 269.05 55)",
    stroke: "url(#paint10_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 276.931 55)",
    stroke: "url(#paint11_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 284.812 55)",
    stroke: "url(#paint12_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 292.693 55)",
    stroke: "url(#paint13_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 300.574 55)",
    stroke: "url(#paint14_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 308.455 55)",
    stroke: "url(#paint15_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 316.337 55)",
    stroke: "url(#paint16_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 324.218 55)",
    stroke: "url(#paint17_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 332.099 55)",
    stroke: "url(#paint18_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 339.98 55)",
    stroke: "url(#paint19_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 347.861 55)",
    stroke: "url(#paint20_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 355.742 55)",
    stroke: "url(#paint21_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 363.624 55)",
    stroke: "url(#paint22_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 371.505 55)",
    stroke: "url(#paint23_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 379.386 55)",
    stroke: "url(#paint24_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 387.267 55)",
    stroke: "url(#paint25_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 395.148 55)",
    stroke: "url(#paint26_linear_5222_29548)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 99.5,
    r: 99.4,
    transform: "matrix(-1 0 0 1 403.03 55)",
    stroke: "url(#paint27_linear_5222_29548)",
    strokeWidth: 0.2
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M270.257 2.53798L267.664 -4.64512C267.195 -5.94626 265.759 -6.61979 264.459 -6.15049C263.158 -5.68119 262.484 -4.24607 262.953 -2.94493L265.546 4.23816C253.08 9.42074 243.084 19.1996 237.631 31.5499C232.177 43.8999 231.682 57.8737 236.25 70.5793C236.475 71.2039 236.94 71.7127 237.541 71.9957C238.142 72.278 238.831 72.3093 239.455 72.0839L240.779 71.6061C241.715 71.2682 242.361 70.4077 242.426 69.4145C242.663 65.7227 244.335 62.271 247.084 59.7949C249.832 57.3198 253.44 56.0178 257.136 56.1668C260.832 56.3169 264.324 57.9054 266.864 60.5948C267.463 61.2415 268.358 61.5252 269.22 61.3417C269.326 61.3115 269.43 61.274 269.531 61.2296C270.243 60.9726 270.8 60.4078 271.047 59.6921C272.965 54.5026 276.401 50.0103 280.907 46.801L293.554 81.8423C295.072 86.0494 298.72 89.1268 303.123 89.9151C307.525 90.7042 312.014 89.084 314.898 85.6652C317.783 82.247 318.625 77.5493 317.106 73.3423C316.637 72.0411 315.202 71.3673 313.901 71.8369C312.6 72.3062 311.927 73.741 312.396 75.0422C313.307 77.5664 312.802 80.3851 311.072 82.4358C309.34 84.4875 306.647 85.4594 304.006 84.9858C301.364 84.5132 299.176 82.6664 298.265 80.1421L285.618 45.1008C291.135 44.7043 296.645 45.9654 301.439 48.7238C302.187 49.1774 303.117 49.2073 303.893 48.8034C304.668 48.3995 305.177 47.6198 305.234 46.747C305.471 43.0552 307.144 39.6032 309.892 37.1274C312.641 34.652 316.249 33.35 319.945 33.4993C323.641 33.6491 327.132 35.2379 329.672 37.9273C330.356 38.6501 331.404 38.8996 332.34 38.5617L333.663 38.0842C334.288 37.8588 334.798 37.3949 335.08 36.7939C335.362 36.1921 335.394 35.504 335.169 34.8794C330.57 22.186 321.264 11.7484 309.181 5.72777C297.096 -0.293561 283.159 -1.43481 270.257 2.53798ZM312.862 29.6194C306.923 31.7661 302.421 36.6976 300.824 42.8071C294.822 39.808 287.92 39.1469 281.458 40.9531C275.331 43.6901 270.441 48.6072 267.739 54.7476C263.082 51.4095 257.176 50.3297 251.64 51.8054C246.105 53.2808 241.519 57.1559 239.142 62.3694C236.812 51.1539 238.607 39.4743 244.198 29.4774C249.788 19.4794 258.798 11.8337 269.573 7.94499C280.347 4.05655 292.163 4.18636 302.851 8.30953C313.537 12.4335 322.377 20.2742 327.747 30.3919C323.092 28.1395 317.726 27.8612 312.864 29.6186L312.862 29.6194Z",
    fill: "#3880B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5222_29548",
    x1: -4.69703e-7,
    y1: 2.9,
    x2: 256.906,
    y2: 211.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5085AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2D5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5222_29548",
    x1: -4.7111e-7,
    y1: 2.925,
    x2: 258.817,
    y2: 211.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7EDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5222_29548",
    x1: 129.5,
    y1: 4,
    x2: 40,
    y2: 170.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1063B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5222_29548",
    x1: 186.806,
    y1: 158.029,
    x2: 48.7745,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66AFD8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmcBg);
export default __webpack_public_path__ + "static/media/GmcBg.7d363d19213e009244d1aa2d70d41f00.svg";
export { ForwardRef as ReactComponent };